export const Boxing = [
    {
        "id": 5,
        "Title": "IES-2024-5",
        "ImageSource": "/Boxing/BoxingGloves/5.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 6,
        "Title": "IES-2024-6",
        "ImageSource": "/Boxing/BoxingGloves/6.jpg",
        "Category": "Bag Gloves"
    },
    {
        "id": 7,
        "Title": "IES-2024-7",
        "ImageSource": "/Boxing/BoxingGloves/7.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 8,
        "Title": "IES-2024-8",
        "ImageSource": "/Boxing/BoxingGloves/8.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 9,
        "Title": "IES-2024-9",
        "ImageSource": "/Boxing/BoxingGloves/9.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 10,
        "Title": "IES-2024-10",
        "ImageSource": "/Boxing/BoxingGloves/10.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 11,
        "Title": "IES-2024-11",
        "ImageSource": "/Boxing/BoxingGloves/11.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 12,
        "Title": "IES-2024-12",
        "ImageSource": "/Boxing/BoxingGloves/12.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 13,
        "Title": "IES-2024-13",
        "ImageSource": "/Boxing/BoxingGloves/13.png",
        "Category": "Bag Gloves"
    },
    {
        "id": 14,
        "Title": "IES-2024-14",
        "ImageSource": "/Boxing/BoxingGloves/14.jpg",
        "Category": "Bag Gloves"
    },
]